<ion-item>

  <ion-label>

    <div class="description time">
      <yu-icon name="clock"></yu-icon>

      <p>
        <span>{{ item.in_date.original_date | date: 'HH:mm' }}</span> a
        <span>{{ item.out_date ? (item.out_date.original_date | date:'HH:mm') : '--:--' }}</span>

        @if (item.out_date && item.ends_on_next_day) {
          <sup>+1</sup>
        }

        @if (item.store) {
          en <span>{{ item.store.name }}</span>
        }
      </p>

      @if (item.automatic) {
        <yu-icon name="warning" color="warning"></yu-icon>
      }
    </div>

  </ion-label>

</ion-item>
